<script>
    import { EntryButton } from "@axel669/zephyr"

    import Subscreen from "./screen/subscreen.svelte"
</script>

<EntryButton component={Subscreen}>
    Show Screen
</EntryButton>
